var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Dropzone } from '../Dropzone';
import { SortableItem } from './SortableItem';
export const SortableGallery = (_a) => {
    var { updateCardsPosition, files, onDelete, style } = _a, rest = __rest(_a, ["updateCardsPosition", "files", "onDelete", "style"]);
    const updateCards = (prevCards, dragIndex, hoverIndex) => {
        const newCards = prevCards.slice();
        [newCards[dragIndex], newCards[hoverIndex]] = [newCards[hoverIndex], newCards[dragIndex]];
        return newCards;
    };
    const moveCard = useCallback((dragIndex, hoverIndex) => {
        updateCardsPosition((prevCards) => updateCards(prevCards, dragIndex, hoverIndex));
    }, []);
    return (React.createElement(DndProvider, { backend: HTML5Backend },
        React.createElement(Dropzone, Object.assign({ style: Object.assign({}, style) }, rest, { files: files, onDelete: onDelete }), files.map((file, index) => (React.createElement(SortableItem, { key: file.id, index: index, id: file.uid, moveCard: moveCard, onDelete: onDelete, image: file, extraStyleHeight: style === null || style === void 0 ? void 0 : style.height }))))));
};
